// @ts-nocheck
import { ArchiveConfiguration } from "./ArchiveConfiguration";

export class ArchiveItemCreate {
    private currentContainer: JQuery;
    private configuration: ArchiveConfiguration;
    private fileUploadButton: JQuery;
    private fileUploadArea: JQuery;
    private uploadedFileNames: JQuery;
    private noSelected: JQuery;
    private saveButton: JQuery;
    private selectedFiles: File[] = [];
    private incorrectFileType: JQuery;

    constructor(private container: JQuery) {
        this.currentContainer = container;
        this.configuration = new ArchiveConfiguration(container);
        this.fileUploadButton = $('#ArchiveFileButton');
        this.fileUploadArea = $('#ArchiveFileData');
        this.uploadedFileNames = $('#UploadedFileName');
        this.incorrectFileType = $('#incorrectFileType');
        this.incorrectFileType.hide();
        this.noSelected = $('.noSelected');
        this.saveButton = $('.add-button');
        this.initialize();
    }

    fileUploadClick(evt) {
        let that = this;
        var allowedExtensions = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".mp4", ".png", ".jpg", ".jpeg", ".gif", ".webp"];

        this.fileUploadArea.on('change', function (e) {
            const file = (<HTMLInputElement>e.target).files[0];
            const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();

            if (allowedExtensions.includes(fileExtension)) {
                if (file && !that.isFileAlreadySelected(file.name)) {
                    that.selectedFiles.push(file); 
                    that.updateFileListDisplay();
                }

                that.clearFileInput(); 
                that.saveButton.show();
                that.incorrectFileType.hide();
            } else {
                that.incorrectFileType.show();
            }
        });

        this.fileUploadArea.click();
    }

    private isFileAlreadySelected(fileName) {
        return this.selectedFiles.some(f => f.name === fileName);
    }

    private clearFileInput() {
        this.fileUploadArea.val(""); 
    }

    private updateFileListDisplay() {
        this.uploadedFileNames.empty();

        this.selectedFiles.forEach(file => {
            let listItem = $('<li class="list-group-item"></li>').text(file.name);
            this.uploadedFileNames.append(listItem);
        });

        this.uploadedFileNames.show();
    }
    
    private submitForm() {
        let form = $('.submitbutton').closest("form");
        if (form.valid()) {
            let submitButton = $('.submitbutton');
            submitButton.prop('disabled', true);

            let formData = new FormData();
            formData.append('Name', $('#Name').val());
            formData.append('ArchiveItemId', $('#ArchiveItemId').val());
            this.selectedFiles.forEach(file => {
                formData.append('files', file);
            });

            let url = form.attr('action');

            const selectedOption = $('input[name="targetGroup"]:checked').val();
            formData.append('selectedOption', selectedOption);

            if (selectedOption === 'Group') {
                $('input[type=checkbox][name="selectedGroups"]:checked').each(function () {
                    formData.append('selectedGroups', $(this).val());
                });
            } else if (selectedOption === 'Organization') {
                $('.organization-item input[type=checkbox]:checked').each(function () {
                    const orgId = $(this).val();
                    formData.append('selectedOrganizations', orgId);
                });
            }

            formData.append('__RequestVerificationToken', form.find("input[name=\"__RequestVerificationToken").val());

            $.ajax({
                url: url,
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {

                    if (typeof (response) !== 'object') {
                        response = JSON.parse(response);
                    }

                    if (response.redirect) {
                        window.location.href = response.redirect;
                    } else {
                        window.scrollTo(0, 0);
                        window.location.reload();
                    }

                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.log("Error", textStatus, errorThrown);
                    submitButton.prop('disabled', false);
                }
            });
        } else {
            console.log("Invalid form");
        }
    }

    private sendNotification() {
        let archiveItemId = $('#ArchiveItemId').val();
        
        let form = $('.notificationbutton').closest("form");
        let url = form.attr('action');

        let notifButton = $('.notificationbutton');
        notifButton.prop('disabled', true);
        
        $.ajax({
            url: url + '?archiveItemId=' + archiveItemId,
            type: 'POST',
            processData: false,
            contentType: false,
            success: function (response) {

                if (typeof (response) !== 'object') {
                    response = JSON.parse(response);
                }

                if (response.redirect) {
                    window.location.href = response.redirect;
                } else {
                    window.scrollTo(0, 0);
                    window.location.reload();
                }

            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log("Error", textStatus, errorThrown);
                notifButton.prop('disabled', false);
            }
        });
    }

    private deleteArchive() {
        let archiveItemId = $('#ArchiveItemId').val();

        let form = $('.deletebutton').closest("form");
        let url = form.attr('action');

        $.ajax({
            url: url + '?archiveItemId=' + archiveItemId,
            type: 'POST',
            processData: false,
            contentType: false,
            success: function (response) {
                if (typeof (response) !== 'object') {
                    response = JSON.parse(response);
                }

                if (response.redirect) {
                    window.location.href = response.redirect;
                } else {
                    window.scrollTo(0, 0);
                    window.location.reload();
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log("Error", textStatus, errorThrown);
            }
        });
    }

    private setupTargetGroupOptions() {
        const $option1 = $('#Group');
        const $option2 = $('#Organization');
        const $radioOption1 = $('#radioOption1');
        const $radioOption2 = $('#radioOption2');
        $option1.hide();
        $option2.hide();

        if ($radioOption1.is(':checked')) {
            $option1.show();
            $option2.hide();
        }
        if ($radioOption2.is(':checked')) {
            $option1.hide();
            $option2.show();
        }

        let that = this;
        $radioOption1.on('change', function () {
            if ($radioOption1.is(':checked')) {
                $option1.show();
                $option2.hide();
                that.updateSelectedOrganizationsList();
            }
        });

        $radioOption2.on('change', function () {
            if ($radioOption2.is(':checked')) {
                $option1.hide();
                $option2.show();
            }
        });
    }

    private updateSelectedOrganizationsList() {
        const selectedOrganizations = [];

        $('.organization-item input[type=checkbox]:checked').each(function () {
            const orgName = $(this).siblings('label').text();
            selectedOrganizations.push(orgName);
        });

        const $organizationDisplayList = $('#organizationDisplayList');
        $organizationDisplayList.empty(); // Clear the list

        selectedOrganizations.forEach(function (org) {
            $organizationDisplayList.append($('<li></li>').text(org));
        });

        if (selectedOrganizations.length > 0) {
            this.noSelected.hide();
        } else {
            this.noSelected.show();
        }
    }

    private initialize() {
        this.fileUploadArea.hide();

        let that = this;
        this.fileUploadButton.on('click', function (evt) {
            evt.preventDefault();
            that.fileUploadClick(evt);
        });

        $('.submitbutton').on('click', function (e) {
            e.preventDefault();
            that.submitForm();
            return false;
        });

        $('.notificationbutton').on('click', function (e) {
            e.preventDefault();
            that.sendNotification();
            return false;
        });

        $('.deletebutton').on('click', function (e) {
            e.preventDefault();
            that.deleteArchive();
            return false;
        });

        this.setupTargetGroupOptions();

        $('#organizationSearch').on('input', function () {
            const searchValue = $(this).val().toLowerCase();

            $('.organization-item').each(function () {
                const itemText = $(this).text().toLowerCase();
                if (itemText.includes(searchValue)) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        });

        $('.organization-item input[type=checkbox]').on('change', function () {
            that.updateSelectedOrganizationsList();
        });
        that.updateSelectedOrganizationsList();
    }
}